import { useEffect } from 'react';
import { TopBar } from '@/ui/layout/TopBar';
import { LeftPanel } from '@/ui/layout/LeftPanel';
import { RightPanel } from '@/ui/layout/RightPanel';
import { BottomBar } from '@/ui/layout/BottomBar';
import { Viewport } from '@/ui/viewport/Viewport';
import { StudioLoader } from '@/ui/viewport/StudioLoader';
import { LeadGate } from '@/ui/lead/LeadGate';
import { WizardSteps } from '@/ui/layout/WizardSteps';
import { useConfiguratorStore } from '@/state/configuratorStore';

export default function App() {
  const ready = useConfiguratorStore(s => s.ready);
  const error = useConfiguratorStore(s => s.error);
  const zones = useConfiguratorStore(s => s.zones);
  const leadUnlocked = useConfiguratorStore(s => s.leadUnlocked);

  useEffect(() => {
    console.info('[app] state', { ready, error, zoneCount: zones.length, leadUnlocked });
  }, [ready, error, zones.length, leadUnlocked]);

  return (
    <div className={`app${leadUnlocked ? '' : ' is-gated'}`}>
      <TopBar />
      <WizardSteps />
      <div className="app__main">
        <LeftPanel />
        <div className="app__center">
          <Viewport />
          <StudioLoader />
          {error && (
            <div className="loading-overlay loading-overlay--error" role="alert">
              <div className="error-card">
                <div className="error-card__logo" aria-hidden>
                  <img src="/assets/UrbanQode_Logo.png" alt="UrbanQode" width={40} height={40} />
                </div>
                <div className="error-card__icon" aria-hidden>
                  !
                </div>
                <h2>Couldn’t start the studio</h2>
                <p className="error-card__msg">{error}</p>
                <p className="error-card__hint">Check network, WebGL support, or asset paths — then retry.</p>
                <p className="error-card__brand">
                  <a href="https://urbanqode.com" target="_blank" rel="noreferrer">
                    UrbanQode.com
                  </a>
                </p>
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => {
                    console.info('[app] retry click');
                    useConfiguratorStore.setState({
                      error: null,
                      ready: false,
                      view3d: null,
                      textureFactory: null,
                      loading: {
                        mode: 'boot',
                        progress: 10,
                        title: 'Restarting studio',
                        detail: 'Rebuilding the 3D workspace…',
                        stage: 'engine',
                      },
                    });
                    window.location.reload();
                  }}
                >
                  Retry
                </button>
              </div>
            </div>
          )}
        </div>
        <RightPanel />
      </div>
      <BottomBar />
      <LeadGate />
    </div>
  );
}
